import clsx from 'clsx';

import styles from './Title.module.scss';

type TitleProps = {
  children: React.ReactNode;
  className?: string;
};

export function Title({ children, className }: TitleProps) {
  return <h2 className={clsx(styles.title, className)}>{children}</h2>;
}
